import { render } from "./BurnAlertModal.vue?vue&type=template&id=901a3c96&ts=true"
import script from "./BurnAlertModal.vue?vue&type=script&lang=ts"
export * from "./BurnAlertModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__